module.exports = __webpack_public_path__ + "img/take3pay2.3966c500.png";